import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Bound } from "lib/@components/binding/Bound"
import { Alert, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { getAccessBreakdown } from "../controller/get-access-breakdown"
import { AccessBreakdown } from "./access-breakdown"

export function ClientAccess() {
    const { clientId } = useBoundContext()
    const breakdown = getAccessBreakdown.useResults({ clientId })

    if (!breakdown) return <LoadingScreen />

    const skus = (breakdown.licences?.effective?.skus ?? []).map(skuOf)

    return (
        <Bound breakdown={breakdown} scope="client" subjectId={clientId} clientId={clientId}>
            <Stack spacing={2} pt={1}>
                <Alert severity="info">
                    <Typography variant="body2">
                        These are the client&apos;s entitlements, previewed as a Create licence user. What an individual
                        user can actually do also depends on their licence type, roles and any user-level overrides
                        &mdash; see the Access tab on their profile.
                    </Typography>
                </Alert>
                <If value={skus.length > 0}>
                    <Typography variant="body2" color="text.secondary">
                        Products held: {skus.join(", ")}
                    </Typography>
                </If>
                <AccessBreakdown />
            </Stack>
        </Bound>
    )
}

function skuOf(entry) {
    return entry?.sku ?? entry
}
